var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPronunciation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37467 13.5416C11.6759 13.5416 13.5413 11.6762 13.5413 9.37498C13.5413 7.07379 11.6759 5.20831 9.37467 5.20831C7.07349 5.20831 5.20801 7.07379 5.20801 9.37498C5.20801 11.6762 7.07349 13.5416 9.37467 13.5416Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37533 15.625C6.59408 15.625 1.04199 17.0208 1.04199 19.7916V21.875H17.7087V19.7916C17.7087 17.0208 12.1566 15.625 9.37533 15.625ZM17.4587 5.58331L15.7087 7.34373C16.5837 8.5729 16.5837 10.1666 15.7087 11.3958L17.4587 13.1562C19.5628 11.0521 19.5628 7.87498 17.4587 5.58331ZM20.9066 2.08331L19.2087 3.78123C22.0941 6.92706 22.0941 11.6562 19.2087 14.9687L20.9066 16.6666C24.9691 12.6146 24.9795 6.30206 20.9066 2.08331Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_2364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPronunciation);
export default __webpack_public_path__ + "static/media/icon_pronunciation.045a649f0fa2f9d6998a31348004ef7f.svg";
export { ForwardRef as ReactComponent };